function i(r, { includeGroup: d = !1, includeSelf: n = !0 }, a) {
  var o;
  const l = a.treeNodeMap;
  let e = r == null ? null : (o = l.get(r)) !== null && o !== void 0 ? o : null;
  const t = {
    keyPath: [],
    treeNodePath: [],
    treeNode: e
  };
  if (e != null && e.ignored)
    return t.treeNode = null, t;
  for (; e; )
    !e.ignored && (d || !e.isGroup) && t.treeNodePath.push(e), e = e.parent;
  return t.treeNodePath.reverse(), n || t.treeNodePath.pop(), t.keyPath = t.treeNodePath.map((u) => u.key), t;
}
export {
  i as getPath
};
